import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import Input from "../../Input/Input";
import { IconWrapper } from "../../Input/styles";

const { carbon, midnight } = colorsPalettes;

export const GeneralSettingsContainer = styled.div`
    width: 500px;
    margin-bottom: 24px;
`;

export const WebsiteWrapper = styled.div`
    margin: 24px 0 24px;
`;

export const CountryFilterWrapper = styled.div<{ isMultiActivation?: boolean }>`
    height: 40px;
    border-radius: 3px;
    position: relative;
    margin-bottom: ${({ isMultiActivation }) => (isMultiActivation ? "48px" : "0")};

    .CountryFilter-dropdownButton {
        ${setFontVariant("body1")};
    }

    .DropdownButton--filtersBarDropdownButton {
        border-left: none;
    }
`;

export const SectionTitle = styled.span<{ marginBottom?: number }>`
    display: flex;
    font-size: 16px;
    font-weight: 500;
    color: ${carbon[400]};

    ${({ marginBottom }) =>
        marginBottom
            ? css`
                  margin-bottom: ${marginBottom}px;
              `
            : ``};
    padding-right: 4px;
`;

export const InfoIconContainer = styled.div`
    padding: 2px 4px 4px;
`;

export const NameInput = styled(Input)`
    input {
        box-shadow: unset;
        padding: 9px 16px;
        color: ${({ isDisabled }) => (isDisabled ? midnight[100] : carbon[500])};
        border: 1px solid ${midnight[50]};

        pointer-events: ${({ isDisabled }) => (isDisabled ? "none" : "auto")};
        cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "auto")};
    }

    ${IconWrapper} {
        top: 7px;
    }
`;
